/* unplugin-vue-components disabled */import script from "./button.vue?vue&type=script&lang=js"
export * from "./button.vue?vue&type=script&lang=js"

import "./button.vue?vue&type=style&index=0&id=41e473d1&lang=scss"

const __exports__ = script;

export default __exports__